module.exports = __webpack_public_path__ + "static/img/1.8473d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/1.png
// module id = vDBw
// module chunks = 0